/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createInvoiceDtoFromDiscriminatorValue, createPagedResultOfInvoiceDtoFromDiscriminatorValue, serializeCreateInvoiceRequest, serializeInvoiceDto, type CreateInvoiceRequest, type ErrorResponse, type InternalErrorResponse, type InvoiceDto, type PagedResultOfInvoiceDto } from '../../models/index.js';
// @ts-ignore
import { BulkRequestBuilderRequestsMetadata, type BulkRequestBuilder } from './bulk/index.js';
// @ts-ignore
import { ByCustomerRequestBuilderNavigationMetadata, type ByCustomerRequestBuilder } from './byCustomer/index.js';
// @ts-ignore
import { ByIdsRequestBuilderRequestsMetadata, type ByIdsRequestBuilder } from './byIds/index.js';
// @ts-ignore
import { ByOrderRequestBuilderNavigationMetadata, type ByOrderRequestBuilder } from './byOrder/index.js';
// @ts-ignore
import { type WithInvoiceItemRequestBuilder, WithInvoiceItemRequestBuilderNavigationMetadata, WithInvoiceItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { OrderSummaryRequestBuilderNavigationMetadata, type OrderSummaryRequestBuilder } from './orderSummary/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/invoices
 */
export interface InvoicesRequestBuilder extends BaseRequestBuilder<InvoicesRequestBuilder> {
    /**
     * The bulk property
     */
    get bulk(): BulkRequestBuilder;
    /**
     * The byCustomer property
     */
    get byCustomer(): ByCustomerRequestBuilder;
    /**
     * The byIds property
     */
    get byIds(): ByIdsRequestBuilder;
    /**
     * The byOrder property
     */
    get byOrder(): ByOrderRequestBuilder;
    /**
     * The orderSummary property
     */
    get orderSummary(): OrderSummaryRequestBuilder;
    /**
     * Gets an item from the MomentumAPI.api.invoices.item collection
     * @param invoiceId Unique identifier of the item
     * @returns {WithInvoiceItemRequestBuilder}
     */
     byInvoiceId(invoiceId: string) : WithInvoiceItemRequestBuilder;
    /**
     * Returns a page of the organization's invoices. Sort on InvoiceDate, DueDate, InvoiceTotal or InvoiceStatus, with a direction of asc or desc. Neither is validated: an unrecognised column silently falls back to InvoiceDate and an unrecognised direction to desc, so a typo returns the wrong ordering rather than an error. A customer sees only their own invoices — any customer filter they send is replaced with their own customer number before the query runs — while an administrator's filters are used as supplied.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<PagedResultOfInvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<InvoicesRequestBuilderGetQueryParameters> | undefined) : Promise<PagedResultOfInvoiceDto | undefined>;
    /**
     * Creates one invoice against an order; at least one line item is required. The invoice starts in Draft, and the issue endpoint moves it to Issued — unless imported totals are supplied, in which case the status is derived from those amounts immediately (Issued, PartiallyPaid or Paid), because an invoice arriving from another system may already be paid. Supplying an invoice number makes this an upsert: an invoice is unique per organization and invoice number, so re-sending the same number updates that invoice rather than creating a duplicate. Omit the number and one is generated.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<InvoiceDto>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(body: CreateInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<InvoiceDto | undefined>;
    /**
     * Returns a page of the organization's invoices. Sort on InvoiceDate, DueDate, InvoiceTotal or InvoiceStatus, with a direction of asc or desc. Neither is validated: an unrecognised column silently falls back to InvoiceDate and an unrecognised direction to desc, so a typo returns the wrong ordering rather than an error. A customer sees only their own invoices — any customer filter they send is replaced with their own customer number before the query runs — while an administrator's filters are used as supplied.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<InvoicesRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Creates one invoice against an order; at least one line item is required. The invoice starts in Draft, and the issue endpoint moves it to Issued — unless imported totals are supplied, in which case the status is derived from those amounts immediately (Issued, PartiallyPaid or Paid), because an invoice arriving from another system may already be paid. Supplying an invoice number makes this an upsert: an invoice is unique per organization and invoice number, so re-sending the same number updates that invoice rather than creating a duplicate. Omit the number and one is generated.
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: CreateInvoiceRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Returns a page of the organization's invoices. Sort on InvoiceDate, DueDate, InvoiceTotal or InvoiceStatus, with a direction of asc or desc. Neither is validated: an unrecognised column silently falls back to InvoiceDate and an unrecognised direction to desc, so a typo returns the wrong ordering rather than an error. A customer sees only their own invoices — any customer filter they send is replaced with their own customer number before the query runs — while an administrator's filters are used as supplied.
 */
export interface InvoicesRequestBuilderGetQueryParameters {
    filters?: string[];
    pageNumber?: number;
    pageSize?: number;
    sortDirection?: string;
    sortOn?: string;
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const InvoicesRequestBuilderUriTemplate = "{+baseurl}/api/invoices?pageNumber={pageNumber}&pageSize={pageSize}&sortDirection={sortDirection}&sortOn={sortOn}{&filters*,useOrganizationId*}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const InvoicesRequestBuilderNavigationMetadata: Record<Exclude<keyof InvoicesRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byInvoiceId: {
        requestsMetadata: WithInvoiceItemRequestBuilderRequestsMetadata,
        navigationMetadata: WithInvoiceItemRequestBuilderNavigationMetadata,
        pathParametersMappings: ["invoiceId"],
    },
    bulk: {
        requestsMetadata: BulkRequestBuilderRequestsMetadata,
    },
    byCustomer: {
        navigationMetadata: ByCustomerRequestBuilderNavigationMetadata,
    },
    byIds: {
        requestsMetadata: ByIdsRequestBuilderRequestsMetadata,
    },
    byOrder: {
        navigationMetadata: ByOrderRequestBuilderNavigationMetadata,
    },
    orderSummary: {
        navigationMetadata: OrderSummaryRequestBuilderNavigationMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const InvoicesRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: InvoicesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createPagedResultOfInvoiceDtoFromDiscriminatorValue,
    },
    post: {
        uriTemplate: InvoicesRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createInvoiceDtoFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeCreateInvoiceRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
